<template>
  <div v-focus :class="['language', { 'language--visible': visible }]" tabindex="0" @keyup.esc="$emit('close')">
    <div class="language__container">
      <div class="language__head">
        <h5 class="language__head-title">{{ $t('navbar.changeLanguage') }}</h5>
        <button type="button" class="btn-close" @click="$emit('close')">
          <img src="@/assets/ic_close_white_24dp_1x.png" alt="Close" />
        </button>
      </div>
      <div class="language__info">
        <div
          v-for="_lang in languages"
          :key="_lang.value"
          class="language__item"
          @click.prevent="lang != _lang.value ? changeLanguage(_lang.value) : null"
        >
          <template v-if="_lang.value === 'en'">
            <img src="@/assets/flags/english.png" class="mr-1" width="32" height="32" />
            <label :class="{ 'language__item--active': lang === _lang.value }">English</label>
          </template>
          <template v-if="_lang.value === 'es'">
            <img src="@/assets/flags/spanish.png" class="mr-1" width="32" height="32" />
            <label :class="{ 'language__item--active': lang === _lang.value }">Español</label>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'LanguageSelector',
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      languages: [
        { value: 'en', label: this.$t('languages.en') },
        { value: 'es', label: this.$t('languages.es') },
      ],
    };
  },
  computed: {
    ...mapGetters({
      lang: 'app/language',
    }),
  },
  methods: {
    changeLanguage(lang) {
      this.$httpMain
        .post(`language`, {
          lang: lang,
        })
        .then(() => {
          this.$store.commit('app/SET_LANGUAGE', lang);
          this.$notify({
            title: 'Success',
            message: this.$t('sidebar.savedSatis'),
            position: 'bottom-right',
            type: 'success',
          });
        })
        .catch(() => {
          this.$notify({
            title: 'Error',
            message: this.$t('messages.ops'),
            position: 'bottom-right',
            type: 'error',
          });
        });
    },
  },
};
</script>

<style lang="sass" scoped>
.language
  position: fixed
  left: 0
  right: 0
  bottom: 0
  top: 0
  background-color: rgba(64, 157, 164, 0.6)
  display: none
  justify-content: center
  align-items: center
  transition: all .5s
  +element('container')
    position: relative
    width: 300px
    height: 150px
    background-color: #fff
    border-radius: 10px
  +element('head')
    padding: 10px
  +element('head-title')
    text-align: center
    font-size: 1.5em
  +element('info')
    padding-top: 1em
    display: flex
    justify-content: center
  +element('item')
    cursor: pointer
    user-select: none
    margin: 0 .5em
    display: flex
    align-items: center
    justify-content: center
    padding: 5px
    +modifier('active')
      font-weight: 900
  +modifier('visible')
    display: flex
.btn-close
  background-color: #dc3545
  border-radius: 50%
  padding: .2em .3em
  border: none
  position: absolute
  right: -5px
  top: -5px
  &:hover
    transform: scale(1.1)
    transition: all .5s ease-out
  &:focus
   outline: none
</style>
